import { BRAND_LOGO } from "./data";
import { SITE_NAME, getSiteUrl } from "./siteConfig";

/**
 * @param {string} [path='']
 */
function absoluteBrandLogo(siteBase) {
  const b = String(siteBase).replace(/\/+$/, "");
  if (!BRAND_LOGO) return b;
  if (/^https?:\/\//i.test(BRAND_LOGO)) return BRAND_LOGO;
  const path = BRAND_LOGO.startsWith("/") ? BRAND_LOGO : `/${BRAND_LOGO}`;
  return `${b}${path}`;
}

export function buildOrganizationAndWebsiteGraph(path = "/") {
  const base = getSiteUrl() || "https://mossmatrix.com";
  const normalized = path.startsWith("/") ? path : `/${path}`;
  const pageUrl = `${base}${normalized}`;
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": `${base}/#organization`,
        name: SITE_NAME,
        url: base,
        logo: absoluteBrandLogo(base),
        description:
          "Premium wildcrafted sea moss gel, blended to order with optional botanicals. Small-batch preparation in the UK.",
      },
      {
        "@type": "WebSite",
        "@id": `${base}/#website`,
        url: base,
        name: SITE_NAME,
        publisher: { "@id": `${base}/#organization` },
        inLanguage: "en-GB",
      },
      {
        "@type": "WebPage",
        "@id": `${pageUrl}#webpage`,
        url: pageUrl,
        isPartOf: { "@id": `${base}/#website` },
        name: SITE_NAME,
      },
    ],
  };
}

/**
 * @param {object} params
 * @param {string} params.name
 * @param {string} params.description
 * @param {string} params.urlPath
 * @param {string} [params.image]
 */
export function buildProductJsonLd({
  name,
  description,
  urlPath,
  image,
  lowPrice = "12.99",
  highPrice = "34.99",
  offerCount = "6",
}) {
  const base = getSiteUrl() || "https://mossmatrix.com";
  const url = `${base}${urlPath.startsWith("/") ? urlPath : `/${urlPath}`}`;
  return {
    "@type": "Product",
    name,
    description,
    url,
    brand: { "@type": "Brand", name: SITE_NAME },
    ...(image ? { image: [image] } : {}),
    offers: {
      "@type": "AggregateOffer",
      priceCurrency: "GBP",
      lowPrice,
      highPrice,
      offerCount,
      availability: "https://schema.org/InStock",
      url,
    },
  };
}

/**
 * @param {{ question: string, answer: string }[]} items
 */
/** FAQ node for embedding inside a larger @graph (omit outer @context). */
export function buildFaqPageJsonLd(items) {
  return {
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };
}
